var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../../services/customAxios", "../../../modules/models/serviceResponse"], function (require, exports, customAxios_1, serviceResponse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    customAxios_1 = __importDefault(customAxios_1);
    serviceResponse_1 = __importDefault(serviceResponse_1);
    var SelfServiceRequest = (function () {
        function SelfServiceRequest(successMs, errorMs) {
            if (successMs === void 0) { successMs = null; }
            if (errorMs === void 0) { errorMs = null; }
            this._toastMs = {
                success: 10000,
                error: 10000
            };
            if (successMs != null && successMs > 0)
                this._toastMs.success = successMs;
            if (errorMs != null && errorMs > 0)
                this._toastMs.error = errorMs;
        }
        SelfServiceRequest.prototype.SearchCpfAndGenerateProtocol = function (payload) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __awaiter(this, void 0, void 0, function () {
                var response, message_1, message, error_1;
                return __generator(this, function (_m) {
                    switch (_m.label) {
                        case 0:
                            _m.trys.push([0, 2, , 3]);
                            return [4, customAxios_1.default.post("/" + SelfServiceRequest._controller + "/GerarProtocolo", payload)];
                        case 1:
                            response = _m.sent();
                            if (!this.IsResponseValid(response) || !((_a = response.data.data) === null || _a === void 0 ? void 0 : _a.success)) {
                                message_1 = (_f = (_d = (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : (_e = response.data) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : SelfServiceRequest._defaultErr.SearchCPF;
                                return [2, Promise.reject(serviceResponse_1.default.Error((_g = response.data) === null || _g === void 0 ? void 0 : _g.data, message_1, false))];
                            }
                            message = (_h = response.data.data.message) !== null && _h !== void 0 ? _h : null;
                            return [2, Promise.resolve(serviceResponse_1.default.Success((_k = (_j = response.data) === null || _j === void 0 ? void 0 : _j.data) !== null && _k !== void 0 ? _k : null, message, false))];
                        case 2:
                            error_1 = _m.sent();
                            console.error(error_1);
                            if (error_1.response) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(null, (_l = error_1.response.data.message) !== null && _l !== void 0 ? _l : SelfServiceRequest._defaultErr.SearchCPF, true))];
                            }
                            else if (error_1.message) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(null, SelfServiceRequest._defaultErr.SearchCPF, true))];
                            }
                            else {
                                return [2, Promise.reject(serviceResponse_1.default.Error(null, SelfServiceRequest._defaultErr.SearchCPF, true))];
                            }
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        SelfServiceRequest.prototype.Respond = function (payload) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __awaiter(this, void 0, void 0, function () {
                var response, message_2, message, error_2;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            _j.trys.push([0, 2, , 3]);
                            return [4, customAxios_1.default.post("/" + SelfServiceRequest._controller + "/GerarResponderTermo", payload)];
                        case 1:
                            response = _j.sent();
                            if (!this.IsResponseValid(response)) {
                                message_2 = (_f = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : (_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : SelfServiceRequest._defaultErr.RespondTerm;
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, message_2, false))];
                            }
                            message = (_g = response.data.message) !== null && _g !== void 0 ? _g : null;
                            return [2, Promise.resolve(serviceResponse_1.default.Success(true, message, false))];
                        case 2:
                            error_2 = _j.sent();
                            console.error(error_2);
                            if (error_2.response) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, (_h = error_2.response.data.message) !== null && _h !== void 0 ? _h : SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            else if (error_2.message) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            else {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        SelfServiceRequest.prototype.GetActivities = function (routeId) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function () {
                var response, message_3, message, error_3;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _f.trys.push([0, 2, , 3]);
                            return [4, customAxios_1.default.get("/" + SelfServiceRequest._controller + "/ObterAtividadesTermo?routeId=" + routeId)];
                        case 1:
                            response = _f.sent();
                            if (!this.IsResponseValid(response)) {
                                message_3 = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : SelfServiceRequest._defaultErr.RespondTerm;
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, message_3, false))];
                            }
                            message = (_c = response.data.message) !== null && _c !== void 0 ? _c : null;
                            return [2, Promise.resolve(serviceResponse_1.default.Success((_d = response.data) === null || _d === void 0 ? void 0 : _d.data, message, false))];
                        case 2:
                            error_3 = _f.sent();
                            console.error(error_3);
                            if (error_3.response) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, (_e = error_3.response.data.message) !== null && _e !== void 0 ? _e : SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            else if (error_3.message) {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            else {
                                return [2, Promise.reject(serviceResponse_1.default.Error(false, SelfServiceRequest._defaultErr.RespondTerm, true))];
                            }
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        SelfServiceRequest.prototype.IsResponseValid = function (response) {
            return response.status >= 200 && response.status <= 299;
        };
        SelfServiceRequest._controller = 'autoatendimento';
        SelfServiceRequest._defaultErr = {
            SearchCPF: 'Ocorreu um erro inesperado ao gerar o protocolo, por favor tente novamente mais tarde',
            RespondTerm: 'Ocorreu um erro inesperado ao gerar termo de consentimento, por favor tente novamente mais tarde'
        };
        return SelfServiceRequest;
    }());
    exports.default = SelfServiceRequest;
});
